export const SELLER_DATA = {
	seller: {
		'@type': 'Organization',
		name: 'Лемана ПРО',
		alternateName: 'Лемана ПРО',
		logo: 'https://cdn.lemanapro.ru/lmru/image/upload/other/logo/logo.svg',
		telephone: '8 (800) 700-00-99',
		email: 'Clients_support@lemanapro.ru',
		url: 'https://lemanapro.ru/',
		sameAs: [
			'https://ru.wikipedia.org/wiki/Leroy_Merlin',
			'https://vk.com/lemanapro',
			'https://ok.ru/lemanapro',
			'https://www.youtube.com/@lemanapro',
			'https://www.wikidata.org/wiki/Q889624',
		],
		foundingDate: '1923',
	},
};
